const Message = ({ notification }) => {
    return (
      <div className="flex flex-col"> 
        <div id="notificationHeader">
          {/* image is optional */}
          {notification?.image && (
            <div id="imageContainer">
              <img src={notification.image} width={100} />
            </div>
          )}
          <span className="text-indigo-500">{notification.title}</span>
        </div>
        <div  className="text-black">{notification.body}</div>
      </div>
    );
  };
  
  export default Message;